import type { Placement } from '@popperjs/core';

export const CUSTOM_VALUE = '__custom__';
export const MARKET_SELECTOR_ORDER_FORM_PLACEMENT: Placement = 'right-start';
export const MARKET_SELECTOR_ORDER_FORM_OFFSET = 22;
export const MARKET_SELECTOR_AGGREGATIONS_WIDTH = 200;
export const DEFAULT_MARKET_SELECTOR_WIDTH = 600;
export const BASE_ADVANCED_MARKET_SELECTOR_WIDTH = 500;
export const DEFAULT_MARKET_SELECTOR_HEIGHT = 500;
export const MARKET_SELECTOR_POPOUT_WINDOW_NAME = 'MarketSelector';

const AGGREGATION_BUTTON_HEIGHT_MARGIN = 64;
export const NARROW_MARKET_SELECTOR_HEIGHT = `min(calc(100vh - ${AGGREGATION_BUTTON_HEIGHT_MARGIN}px), 500px)`;
